import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { GlobalService } from '../services/global.service';
import { PagerService } from '../services/pager.service';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import Utils from '../shared/utility';

@Component({
  selector: 'app-metrics-v2',
  templateUrl: './metrics-v2.component.html',
  styleUrls: ['./metrics-v2.component.css']
})

export class MetricsComponentV2 implements OnInit {
  public hcExpressMessage: string = 'Healthcare illustrations listed in Metrics reporting may include Healthcare Express Reports run by users. The profiles for which these reports were run may or may not have been converted into Clients, based on the user’s discretion.';
  public ltcMapMessage: string = "Report featuring Long-Term Care Map Application usage summary. Includes user's name and inputs for each individual illustration generated on the Map during the specified period of time.";

  public startDate: any = {};
  public endDate: any = {};
  public allTimeChecked: boolean = false;

  public allItems: any[];
  public pager: any = {};
  public pagedItems: any[];

  public showLTC: boolean = true;

  public activeView = {
    org: false,
    advisor: false,
    client: false,
  };

  public orgs: any[];
  public advisors: any[];
  public clients: any[];

  public selectedOrganizationName: string;
  public selectedAdvisorName: string;

  public datePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
  };

  public globalMetrics: any[];
  public globalSearchMetrics: any[];
  public filteredSearch: any[];

  public isOA: boolean;
  public isS: boolean;
  public isA: boolean;

  public showResults: string = "'All-time' refers to the beginning of this application's availability to users in your organization, through today.";
  
  constructor(public globalService: GlobalService, public snackBarService: SnackBarService, public pagerService: PagerService, public loadingService: LoadingService) {
    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
    this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));
    this.globalService.featExpressHealthcare = JSON.parse(localStorage.getItem('featExpressHealthcare'));
    this.globalService.featLTCMapReporting = JSON.parse(localStorage.getItem('featLTCMapReporting'));
  }

  
  metricForm: FormGroup; 
  ngOnInit() {
    this.pagedItems = new Array(10);

    this.isOA = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;

    this.showLTC = !this.isOA && !this.isS && !this.isA;

    const todaysDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);

    // this.startDate = { jsdate: new Date((todaysDate.getFullYear()).toString() + '-' + 1 + '-' + 1) };
    this.startDate = { jsdate: startDate };
    this.endDate = { jsdate: new Date(todaysDate.getFullYear().toString() + '-' + (todaysDate.getMonth() + 1) + '-' + (startDate.getDate() + 1) ) };

    this.metricForm = new FormGroup({
      startDate: new FormControl(this.startDate.jsdate, [Validators.required]),
      endDate: new FormControl(this.endDate.jsdate, [Validators.required]),
      showAllResults: new FormControl(false)
    });

    //this.getOrgMetrics();
    this.getGlobalSearchMetrics();


    if (this.isOA)
      this.getGlobalOAMetrics();
    else
      this.getGlobalMetrics();

    this.getOrgMetrics();
  }

  getOrgMetrics() {

    // this.loadingService.isLoading(true);
    
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults//this.allTimeChecked,
    }
   let dateNow = new Date();
    if ((Date.parse(this.metricForm.value.startDate) >= Date.parse(this.metricForm.value.endDate)) && !this.allTimeChecked) {
      console.log('here 02');
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
      this.pagedItems = null;
      this.loadingService.isLoading(false);
    } else if ((Date.parse(this.metricForm.value.startDate) >= Date.parse(dateNow.toDateString())) && !this.allTimeChecked) {
      console.log('here 02');
      this.snackBarService.add('Please make sure the start date is not future date.', 1);
      this.pagedItems = null;
      this.loadingService.isLoading(false);
    }  else {
      console.log('object used', metricObject);
      this.globalService.getMetricData(metricObject)
        .subscribe(
          orgs => {
            this.activeView = {
              org: true,
              advisor: false,
              client: false,
            }
            this.orgs = orgs;
            console.log('metrics', orgs);
            this.setOrgPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getAdvisorMetrics(orgID) {
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults,//this.allTimeChecked,
      orgID: orgID, //Number(localStorage.getItem('orgID')),
      
    }

    //this.loadingService.isLoading(true);

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getAdvisorMetricData(metricObject)
        .subscribe(
          advisors => {
            this.activeView = {
              org: false,
              advisor: true,
              client: false,
            }

            this.advisors = advisors;
            this.setAdvisorPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getClientMetrics(advisorID, selectedItem = null) {
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults,//this.allTimeChecked,
      advisorID: advisorID, //Number(localStorage.getItem('orgID')),
      
    }

    //this.loadingService.isLoading(true);

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getClientMetricData(metricObject)
        .subscribe(
          clients => {
            var spouses;
            this.activeView = {
              org: false,
              advisor: false,
              client: true,
            }
            // spouses = JSON.parse(clients.Spouses) || [];
            clients.map((client) => {
              if (client.Spouses) {
                spouses = JSON.parse(client.Spouses) || [];
                console.log('here i am', spouses);
                if (spouses.length > 0) {
                  if (spouses && spouses[0].maritalStatus == 'Married') {
                    client.Client_Name = client.Client_Name + " and " + spouses[0].firstName + " " + spouses[0].lastName;
                  }
                }

              }
            });

            // if clicked on client -> filter all clients to display specific client
            if (selectedItem && selectedItem.Type == "Client")
              clients = clients.filter((client) => client.Client_ID == selectedItem.ClientID);

            this.clients = clients;
            this.setClientPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getGlobalOAMetrics() {
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),//this.endDate.jsdate.toUTCString(),
      allTime: this.metricForm.value.showAllResults//this.allTimeChecked,
    }

    if ((Date.parse(this.startDate.jsdate) >= Date.parse(this.endDate.jsdate) && !this.allTimeChecked)) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalOAMetricData(metricObject)
        .subscribe(
          data => {
            //this.loadingService.isLoading(false);
            this.globalMetrics = data.clientMetrics;
          },
          error => console.log(error));
    }
  }

  getGlobalMetrics() {
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults//this.allTimeChecked,
    }

    if ((Date.parse(this.startDate.jsdate) >= Date.parse(this.endDate.jsdate)) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalMetricData(metricObject)
        .subscribe(
          data => {
            //this.loadingService.isLoading(false);
            this.globalMetrics = [data.clientMetrics];
            console.log('global', this.globalMetrics);
          },
          error => console.log(error));
    }
  }

  getGlobalSearchMetrics() {
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults//this.allTimeChecked,
    }
    // if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      if ((Date.parse(this.metricForm.value.startDate) >= Date.parse(this.metricForm.value.endDate)) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalSearchMetricData(metricObject)
        .subscribe(
          data => {
            this.globalSearchMetrics = data.result;
            this.allItems = this.globalSearchMetrics;
          },
          error => console.log(error));
    }
  }

  setOrgPage(page: number) {
    this.pager = this.pagerService.getPager(this.orgs.length, page);
    if (this.orgs.length === 1) {
      this.pagedItems = this.orgs;
      this.pager = this.pagerService.getPager(this.orgs.length, page);
      return;
    }
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.orgs.length, page);
    this.pagedItems = this.orgs.slice(this.pager.startIndex, this.pager.endIndex + 1);
    console.log('this.pagedItems', this.pagedItems)

  }

  setAdvisorPage(page: number) {
    if (this.advisors.length === 1) {
      this.pagedItems = this.advisors;
      this.pager = this.pagerService.getPager(this.advisors.length, page);
      return;
    }

    console.log('set advisor', page);
    if (page < 1 || page > this.pager.totalPages) {
      console.log('shouldnt be in here');
      return;
    }

    this.pager = this.pagerService.getPager(this.advisors.length, page);
    this.pagedItems = this.advisors.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  setClientPage(page: number) {
    if (this.clients.length === 1) {
      this.pagedItems = this.clients;
      this.pager = this.pagerService.getPager(this.clients.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.clients.length, page);
    this.pagedItems = this.clients.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  public selectedOrganization: number = Number(localStorage.getItem('orgID'));
  public selectedAdvisor: number = 0;

  initAdvisorMetrics(org) {
    if (org) {
      this.selectedOrganization = org.ID;
      this.selectedOrganizationName = org.Name;
    }

    this.loadingService.isLoading(true);
    this.getAdvisorMetrics(this.selectedOrganization);
  }

  initClientMetrics(advisor) {
    if (advisor) {
      this.selectedAdvisor = advisor.Advisor_ID;
      this.selectedAdvisorName = advisor.Name;
    }

    this.loadingService.isLoading(true);
    this.getClientMetrics(this.selectedAdvisor);
  }

  initOrgMetrics() {
    this.loadingService.isLoading(true);
    this.getOrgMetrics();
  }

  checkAllTimeChecked() {
    this.allTimeChecked = !this.allTimeChecked;
    this.generateData();
  }

  generateData() {
    this.getGlobalSearchMetrics()

    if (this.isOA)
      this.getGlobalOAMetrics();
    else
      this.getGlobalMetrics();

    if (!this.activeView.org && !this.activeView.advisor && !this.activeView.client)
      this.activeView.org = true;

    if (this.activeView.org) {
      this.getOrgMetrics();
    } else if (this.activeView.advisor) {
      this.getAdvisorMetrics(this.selectedOrganization);
    } else if (this.activeView.client) {
      this.getClientMetrics(this.selectedAdvisor);
    }
  }

  filterSearchItem(value) {
    this.filteredSearch = Object.assign([], this.allItems).filter(
      item => {
        const spouseObject = item.Spouses ? JSON.parse(item.Spouses) : {};
        const spouseName = item.Spouses ? spouseObject[0].maritalStatus.toLowerCase() == "married" ? spouseObject[0].firstName + " " + spouseObject[0].lastName : "" : "";
        if (value.length >= 1) {
          if (item.Type == 'Organization')
            return (item.OrganizationName).toLowerCase().includes(value.toLowerCase())
          if (item.Type == 'Advisor')
            return (item.AdvisorName).toLowerCase().includes(value.toLowerCase())
          if (item.Type == 'Client')
            return (item.ClientName + " and " + spouseName).toLowerCase().includes(value.toLowerCase())
        } else {
          this.filteredSearch = [];
          return;
        }
      }
    );

    /* if (!this.filteredSearch.length) {
      this.pagedItems = [];
    } else {
      if (item.Type == 'Organization')
      return (item.OrganizationName).toLowerCase().includes(value.toLowerCase())
    if (item.Type == 'Advisor')
      return (item.AdvisorName).toLowerCase().includes(value.toLowerCase())
    if (item.Type == 'Client')
      return (item.ClientName).toLowerCase().includes(value.toLowerCase())
    } */
  }

/*   filterItem(value) {
    this.filteredAdvisors = Object.assign([], this.allItems).filter(
      advisor => {
        return (advisor.FirstName + " " + advisor.LastName).toLowerCase().includes(value.toLowerCase()) || (advisor.OrganizationName).toLowerCase().includes(value.toLowerCase()) || (advisor.Phone).toLowerCase().includes(value.toLowerCase()) || (advisor.Email).toLowerCase().includes(value.toLowerCase())
      }
    );

    if (!this.filteredAdvisors.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  } */

  @ViewChild('searchInput') searchInput; 

  loadSearchItem(item) {
    this.loadingService.isLoading(true);

    if (item.Type == 'Organization') {
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedOrganization = item.OrgID;
      this.getAdvisorMetrics(item.OrgID);
    } else if (item.Type == 'Advisor') {
      this.selectedAdvisorName = item.AdvisorName;
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedAdvisor = item.AdvID;
      this.getClientMetrics(item.AdvID);
    } else if (item.Type == 'Client') {
      this.selectedAdvisorName = item.AdvisorName;
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedAdvisor = item.AdvID;
      this.getClientMetrics(item.AdvID, item);
    }

    this.searchInput.nativeElement.value = '';
    this.filteredSearch = [];
  }

  downloadReport() {
    this.loadingService.isLoading(true);
    const metricObject = {
      startDate: this.metricForm.value.startDate.toUTCString(),//this.startDate.jsdate.toUTCString(),
      endDate: this.metricForm.value.endDate.toUTCString(),
      allTime: this.metricForm.value.showAllResults//this.allTimeChecked,
    }

    if (false) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.snackBarService.add('Please wait while your usage report is being generated.', 0);
      this.globalService.getMetricDownloadableReport(metricObject)
        .subscribe(
          data => {
            this.loadingService.isLoading(false);

          },
          error => console.log(error));
    }
  }

  downloadLTCMapReport(){
    this.loadingService.isLoading(true);
    this.snackBarService.add('Please wait while your usage report is being generated.', 0);
      this.globalService.getLTCMapDownloadableReport()
        .subscribe(
          data => {
            this.loadingService.isLoading(false);

          },
          error => console.log(error));    
  }

  formatName(name) {
    var splitStr = name.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    return splitStr.join(' '); 
  }

  numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatSpouseName(spouses) {
    const spouseObject = JSON.parse(spouses);
    return spouseObject[0].firstName + " " + spouseObject[0].lastName
  }

  checkMaritalStatus(spouses) {
    const spouseObject = JSON.parse(spouses);
    return spouseObject[0].maritalStatus.toLowerCase() == "married" ? true : false;
  }

/*   activeMetricNameArrow: boolean;
  activeOrgNameArrow: boolean;
  sort(colName) {

    if (colName == 'metricName') {
      this.globalMetrics.sort((a, b) => a.Name.localeCompare(b.Name ));
      this.activeMetricNameArrow = true;
    }

    if (colName == 'Name') {
      this.pagedItems.sort((a, b) => a.Name.localeCompare(b.Name ));
      this.activeOrgNameArrow = true;
    }

  }

  onDateChanged() {

  } */

}
